import timeUtils from '@/utils/timeUtils.ts';
import { Card, CardContent, InnerCardHeader } from '@/components/ui/Card.tsx';
import Chip from '@/components/ui/Chip.tsx';
import React from 'react';
import { InstallmentDto } from '@/features/public/booking/types/BookingQuoteDto.ts';
import { paymentMethodLabels } from '@/features/dashboard/tourConfig/types/PaymentMethod.utils.ts';

const InstallmentSummaryCard = ({
  index,
  installment,
}: {
  index: number;
  installment: InstallmentDto;
}) => {
  return (
    <Card>
      <InnerCardHeader className="py-2">
        <div className="flex justify-between gap-1">
          <p className="text-sm font-semibold">Rata {index + 1}</p>
          <span className="text-sm font-medium">
            {timeUtils.toDateString(installment.dueDate)}
          </span>
        </div>
      </InnerCardHeader>
      <CardContent className="space-y-2 p-3 py-2">
        <div className="flex flex-row justify-between">
          <div className="text-sm text-neutral-700">Całkowita kwota raty</div>
          <div className="text-sm font-bold text-base-text">
            {installment.amounts
              .map((amount) => `${amount.amount} ${amount.currency} `)
              .join(', ')}
          </div>
        </div>
        <div className="flex flex-row justify-between gap-1">
          <div className="text-sm text-neutral-700">
            Akceptowana forma płatności
          </div>
          <div className="flex flex-row flex-wrap justify-end gap-1">
            {installment.allowedPaymentMethods.map((method) => (
              <Chip
                key={method}
                label={paymentMethodLabels[method] ?? method}
                tone="neutral"
                fill="soft"
              />
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default InstallmentSummaryCard;
